import { formatNumber } from '../../../core/helpers';
import './ThresholdIndicator.scss';

export default function ThresholdIndicator() {
  return (
    <div className='ThresholdIndicator w-100 position-relative mt-4'>
      <div className='ThresholdIndicator__text position-absolute'>
        {formatNumber(10000)}+
      </div>
      <div className='ThresholdIndicator__point position-absolute' />
    </div>
  );
}
